import {HTTP} from "@/helpers/http-common"
import * as R from "ramda";

const get = (perfil) =>new Promise((resolve,reject)=>{
  const {username} = perfil;
  HTTP.get(
    `/api/perfilUsario/${username}`
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error);
  });
});

const update = (perfil) =>new Promise((resolve,reject)=>{
  const {username, foto} = perfil;
  HTTP
  .put(
    '/api/perfilUsario'
    , {username, foto}
  ).then(response=>{
    resolve(response);
  }).catch(error=>{
    reject(error.response);
  });
});

//Export methods
export default {
  get  
  , update
}





// WEBPACK FOOTER //
// ./src/services/seguridad/perfilUsuario/index.js